<div class="product-details">
  @if (model) {
    <span class="model"> {{ model.name }} {{ model.value }} </span>
  }
  <h1>{{ activeVariant().name }}</h1>
  @if (activeVariant(); as activeVariant) {
    @if (activeVariant.price.current > 0) {
      @if (activeVariant.price.current >= activeVariant.price.original) {
        <app-price
          [priceValue]="{
            regularPrice: activeVariant.price.current,
          }"
        ></app-price>
      } @else {
        <app-price
          [priceValue]="{
            regularPrice: activeVariant.price.original,
            promoPrice: activeVariant.price.current,
            omnibusPrice: activeVariant.price.original,
          }"
        ></app-price>
      }
    } @else {
      <span class="no-price" *transloco="let t">
        {{ t('Price unavailable') }}
      </span>
    }

    @if (optionTypes.length > 0) {
      <app-product-options
        [isProductDropdown]="true"
        [activeVariant]="activeVariant"
        (activeVariantOptionsChange)="onVariantChange($event)"
        [options]="optionTypes"
      ></app-product-options>
    }
  }
</div>
@if (optionTypes.length > 0) {
  <div class="sizes">
    <a [href]="sizeUrl" *transloco="let t" target="_blank">{{ t('Check the size') }}</a>
  </div>
}
<div class="action-section" *transloco="let t">
  <div class="submit-section">
    <button
      app-button
      class="add-to-cart"
      type="submit"
      [disabled]="isButtonDisabled()"
      (click)="onSubmit()"
    >
      {{ isButtonDisabled() ? t('Product unavailable') : t('Add to cart') }}
    </button>
    @if (auth.isLoggedIn()) {
      @if (isProductInWishlist()) {
        <button
          class="add-to-wishlist in-wishlist"
          app-button="icon-button"
          (click)="removeFromWishlist($event)"
        >
          <svg-icon key="wishlist"></svg-icon>
        </button>
      } @else {
        <button
          class="add-to-wishlist"
          app-button="icon-button"
          (click)="addToWishlist($event)"
        >
          <svg-icon key="wishlist"></svg-icon>
        </button>
      }
    }
  </div>

  <app-availability-at-showrooms
    [sku]="activeVariant().variantSku"
    (clicked)="onCheckAvailability()"
  ></app-availability-at-showrooms>
</div>
@if (error()) {
  <div class="error">
    <p>{{ error()?.['addItem'] }}</p>
  </div>
}
<p class="shipping-days" *transloco="let t">
  {{ t('Delivery time') }}:
  <span>
    @if (activeVariant().daysCompletionTime) {
      <span>
        {{ activeVariant().daysCompletionTime }}
      </span>
    } @else {
      {{ t('in about') }} 4
    }

    {{ t('business days') }}
  </span>
</p>

@if (locale !== 'en') {
  <p class="shipping-info">
    <span *transloco="let t">{{ t('Free shipping from') }}</span>
  </p>
}

<!--<app-product-info-->
<!--  [stock]="+product.stockAmount"-->
<!--  [deliveryTime]="+product.deliveryTime"-->
<!--&gt;</app-product-info>-->
<!--<app-product-icons-info></app-product-icons-info>-->
<!--TODO: Hidden unnecessary things - MVP-->
